export enum PoojariActionTypes {
    API_RESPONSE_SUCCESS = '@@poojari/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@poojari/API_RESPONSE_ERROR',

    GET_POOJARIS = '@@poojari/GET_POOJARIS',
    RESET = '@@poojari/RESET',
    GET_POOJARI_DETAILS = '@@poojari/GET_POOJARI_DETAILS',
    UPDATE_POOJARI = '@@poojari/UPDATE_POOJARI',
    ADD_POOJARI = '@@poojari/ADD_POOJARI',
    DELETE_POOJARI = '@@poojari/DELETE_POOJARI',
    GET_ALL_RITUALS = '@@poojari/GET_ALL_RITUALS',
}
